module.exports = __webpack_public_path__ + "img/office_2.07328309.jpeg";